// @flow
import config from '../../config';
import { buildQueryParams } from './search-shipments-kpis-request';
import { createApiCall } from './api-factory';

const BASE_URL = config.SHIPMENTS_ANALYTICS_URL;

const makeApiCall = createApiCall(BASE_URL, buildQueryParams);

const getShipmentsNoShipments = (query): any => makeApiCall('/shipments_count', query);

const getShipmentsNoCustomers = (query): any => makeApiCall('/customers_count', query);

const getShipmentsTotalCost = (query): any => makeApiCall('/total_cost', query);

const getShipmentsBaseCost = (query): any => makeApiCall('/base_cost', query);

const getShipmentsAverageCost = (query): any => makeApiCall('/average_cost', query);

const getShipmentsNoShipmentsByTimeframe = (query): any =>
    makeApiCall('/shipments_count_by_timeframe', query);

const getShipmentsCarriers = (query): any => makeApiCall('/carriers', query);

const getShipmentsDestinations = (query): any => makeApiCall('/destinations', query);

const getShipmentsSources = (query): any => makeApiCall('/sources', query);

const getShipmentsCountByZipCode = (query): any => makeApiCall('/shipments_count_by_zip_code', query);

const getShipFromLocations = (query) => makeApiCall('/ship_from_locations', query);

const getAggregatedCostByService = (query) => makeApiCall('/aggregated_cost_by_service', query);

export {
    getShipmentsNoShipments,
    getShipmentsNoCustomers,
    getShipmentsTotalCost,
    getShipmentsBaseCost,
    getShipmentsAverageCost,
    getShipmentsNoShipmentsByTimeframe,
    getShipmentsCarriers,
    getShipmentsDestinations,
    getShipmentsSources,
    getShipmentsCountByZipCode,
    getShipFromLocations,
    getAggregatedCostByService,
};
